// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/resources/error.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Obligation } from "../../../authz_engines/obligations/obligations";
export const protobufPackage = "squareup.connect.v2.resources";
/**
 * --
 * @desc Indicates which high-level category of error has occurred during a
 * request to the Connect API.
 * --
 */
export var Error_Category;
(function (Error_Category) {
    /**
     * API_ERROR - --
     * @desc An error occurred with the Connect API itself.
     * --
     */
    Error_Category[Error_Category["API_ERROR"] = 1] = "API_ERROR";
    /**
     * AUTHENTICATION_ERROR - --
     * @desc An authentication error occurred. Most commonly, the request had
     * a missing, malformed, or otherwise invalid `Authorization` header.
     * --
     */
    Error_Category[Error_Category["AUTHENTICATION_ERROR"] = 2] = "AUTHENTICATION_ERROR";
    /**
     * INVALID_REQUEST_ERROR - --
     * @desc The request was invalid. Most commonly, a required parameter was
     * missing, or a provided parameter had an invalid value.
     * --
     */
    Error_Category[Error_Category["INVALID_REQUEST_ERROR"] = 3] = "INVALID_REQUEST_ERROR";
    /**
     * RATE_LIMIT_ERROR - --
     * @desc Your application reached the Square API rate limit. You might receive this error if your application sends a high number of requests
     * to Square APIs in a short period of time.
     *
     * Your application should monitor responses for `429 RATE_LIMITED` errors and use a retry mechanism with an [exponential backoff](https://en.wikipedia.org/wiki/Exponential_backoff)
     * schedule to resend the requests at an increasingly slower rate. It is also a good practice to use a randomized delay (jitter) in your retry schedule.
     * --
     */
    Error_Category[Error_Category["RATE_LIMIT_ERROR"] = 4] = "RATE_LIMIT_ERROR";
    /**
     * PAYMENT_METHOD_ERROR - --
     * @desc An error occurred while processing a payment method. Most commonly,
     * the details of the payment method were invalid (such as a card's CVV
     * or expiration date).
     * --
     */
    Error_Category[Error_Category["PAYMENT_METHOD_ERROR"] = 5] = "PAYMENT_METHOD_ERROR";
    /**
     * REFUND_ERROR - --
     * @desc An error occurred while attempting to process a refund.
     * --
     */
    Error_Category[Error_Category["REFUND_ERROR"] = 6] = "REFUND_ERROR";
    /** MERCHANT_SUBSCRIPTION_ERROR - @desc An error occurred when checking a merchant subscription status */
    Error_Category[Error_Category["MERCHANT_SUBSCRIPTION_ERROR"] = 7] = "MERCHANT_SUBSCRIPTION_ERROR";
    /** EXTERNAL_VENDOR_ERROR - @desc An error that is returned from an external vendor's API */
    Error_Category[Error_Category["EXTERNAL_VENDOR_ERROR"] = 8] = "EXTERNAL_VENDOR_ERROR";
    Error_Category[Error_Category["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Error_Category || (Error_Category = {}));
/**
 * --
 * @desc Indicates the specific error that occurred during a request to a
 * Square API.
 * --
 */
export var Error_Code;
(function (Error_Code) {
    /**
     * INTERNAL_SERVER_ERROR - --
     * @desc A general server error occurred.
     * --
     */
    Error_Code[Error_Code["INTERNAL_SERVER_ERROR"] = 5000000] = "INTERNAL_SERVER_ERROR";
    /**
     * UNAUTHORIZED - --
     * @desc A general authorization error occurred.
     * --
     */
    Error_Code[Error_Code["UNAUTHORIZED"] = 4010000] = "UNAUTHORIZED";
    /**
     * ACCESS_TOKEN_EXPIRED - --
     * @desc The provided access token has expired.
     * --
     */
    Error_Code[Error_Code["ACCESS_TOKEN_EXPIRED"] = 4010001] = "ACCESS_TOKEN_EXPIRED";
    /**
     * ACCESS_TOKEN_REVOKED - --
     * @desc The provided access token has been revoked.
     * --
     */
    Error_Code[Error_Code["ACCESS_TOKEN_REVOKED"] = 4010002] = "ACCESS_TOKEN_REVOKED";
    /**
     * CLIENT_DISABLED - --
     * @desc The provided client has been disabled.
     * --
     */
    Error_Code[Error_Code["CLIENT_DISABLED"] = 4010003] = "CLIENT_DISABLED";
    /**
     * FORBIDDEN - --
     * @desc A general access error occurred.
     * --
     */
    Error_Code[Error_Code["FORBIDDEN"] = 4030000] = "FORBIDDEN";
    /**
     * INSUFFICIENT_SCOPES - --
     * @desc The provided access token does not have permission
     * to execute the requested action.
     * --
     */
    Error_Code[Error_Code["INSUFFICIENT_SCOPES"] = 4030001] = "INSUFFICIENT_SCOPES";
    /**
     * APPLICATION_DISABLED - --
     * @desc The calling application was disabled.
     * --
     */
    Error_Code[Error_Code["APPLICATION_DISABLED"] = 4030002] = "APPLICATION_DISABLED";
    /**
     * V1_APPLICATION - --
     * @desc The calling application was created prior to
     * 2016-03-30 and is not compatible with v2 Square API calls.
     * --
     */
    Error_Code[Error_Code["V1_APPLICATION"] = 4030003] = "V1_APPLICATION";
    /**
     * V1_ACCESS_TOKEN - --
     * @desc The calling application is using an access token
     * created prior to 2016-03-30 and is not compatible with v2 Square API
     * calls.
     * --
     */
    Error_Code[Error_Code["V1_ACCESS_TOKEN"] = 4030004] = "V1_ACCESS_TOKEN";
    /**
     * CARD_PROCESSING_NOT_ENABLED - --
     * @desc The location provided in the API call is not
     * enabled for credit card processing.
     * --
     */
    Error_Code[Error_Code["CARD_PROCESSING_NOT_ENABLED"] = 4030005] = "CARD_PROCESSING_NOT_ENABLED";
    /** MERCHANT_SUBSCRIPTION_NOT_FOUND - @desc A required subscription was not found for the merchant */
    Error_Code[Error_Code["MERCHANT_SUBSCRIPTION_NOT_FOUND"] = 4030006] = "MERCHANT_SUBSCRIPTION_NOT_FOUND";
    /**
     * BAD_REQUEST - --
     * @desc A general error occurred with the request.
     * --
     */
    Error_Code[Error_Code["BAD_REQUEST"] = 4000000] = "BAD_REQUEST";
    /**
     * MISSING_REQUIRED_PARAMETER - --
     * @desc The request is missing a required path, query, or
     * body parameter.
     * --
     */
    Error_Code[Error_Code["MISSING_REQUIRED_PARAMETER"] = 4000001] = "MISSING_REQUIRED_PARAMETER";
    /**
     * INCORRECT_TYPE - --
     * @desc The value provided in the request is the wrong
     * type. For example, a string instead of an integer.
     * --
     */
    Error_Code[Error_Code["INCORRECT_TYPE"] = 4000002] = "INCORRECT_TYPE";
    /**
     * INVALID_TIME - --
     * @desc Formatting for the provided time value is
     * incorrect.
     * --
     */
    Error_Code[Error_Code["INVALID_TIME"] = 4000003] = "INVALID_TIME";
    /**
     * INVALID_TIME_RANGE - --
     * @desc The time range provided in the request is invalid.
     * For example, the end time is before the start time.
     * --
     */
    Error_Code[Error_Code["INVALID_TIME_RANGE"] = 4000004] = "INVALID_TIME_RANGE";
    /**
     * INVALID_VALUE - --
     * @desc The provided value is invalid. For example,
     * including `%` in a phone number.
     * --
     */
    Error_Code[Error_Code["INVALID_VALUE"] = 4000005] = "INVALID_VALUE";
    /**
     * INVALID_CURSOR - --
     * @desc The pagination cursor included in the request is
     * invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_CURSOR"] = 4000006] = "INVALID_CURSOR";
    /**
     * UNKNOWN_QUERY_PARAMETER - --
     * @desc The query parameters provided is invalid for the
     * requested endpoint.
     * --
     */
    Error_Code[Error_Code["UNKNOWN_QUERY_PARAMETER"] = 4000007] = "UNKNOWN_QUERY_PARAMETER";
    /**
     * CONFLICTING_PARAMETERS - --
     * @desc One or more of the request parameters conflict with
     * each other.
     * --
     */
    Error_Code[Error_Code["CONFLICTING_PARAMETERS"] = 4000008] = "CONFLICTING_PARAMETERS";
    /**
     * EXPECTED_JSON_BODY - --
     * @desc The request body is not a JSON object.
     * --
     */
    Error_Code[Error_Code["EXPECTED_JSON_BODY"] = 4000009] = "EXPECTED_JSON_BODY";
    /**
     * INVALID_SORT_ORDER - --
     * @desc The provided sort order is not a valid key.
     * Currently, sort order must be `ASC` or `DESC`.
     * --
     */
    Error_Code[Error_Code["INVALID_SORT_ORDER"] = 4000010] = "INVALID_SORT_ORDER";
    /**
     * VALUE_REGEX_MISMATCH - --
     * @desc The provided value does not match an expected
     * regular expression.
     * --
     */
    Error_Code[Error_Code["VALUE_REGEX_MISMATCH"] = 4000061] = "VALUE_REGEX_MISMATCH";
    /**
     * VALUE_TOO_SHORT - --
     * @desc The provided string value is shorter than the
     * minimum length allowed.
     * --
     */
    Error_Code[Error_Code["VALUE_TOO_SHORT"] = 4000057] = "VALUE_TOO_SHORT";
    /**
     * VALUE_TOO_LONG - --
     * @desc The provided string value is longer than the
     * maximum length allowed.
     * --
     */
    Error_Code[Error_Code["VALUE_TOO_LONG"] = 4000011] = "VALUE_TOO_LONG";
    /**
     * VALUE_TOO_LOW - --
     * @desc The provided value is less than the supported
     * minimum.
     * --
     */
    Error_Code[Error_Code["VALUE_TOO_LOW"] = 4000012] = "VALUE_TOO_LOW";
    /**
     * VALUE_TOO_HIGH - --
     * @desc The provided value is greater than the supported
     * maximum.
     * --
     */
    Error_Code[Error_Code["VALUE_TOO_HIGH"] = 4000058] = "VALUE_TOO_HIGH";
    /**
     * VALUE_EMPTY - --
     * @desc The provided value has a default (empty) value
     * such as a blank string.
     * --
     */
    Error_Code[Error_Code["VALUE_EMPTY"] = 4000059] = "VALUE_EMPTY";
    /**
     * ARRAY_LENGTH_TOO_LONG - --
     * @desc The provided array has too many elements.
     * --
     */
    Error_Code[Error_Code["ARRAY_LENGTH_TOO_LONG"] = 4000073] = "ARRAY_LENGTH_TOO_LONG";
    /**
     * ARRAY_LENGTH_TOO_SHORT - --
     * @desc The provided array has too few elements.
     * --
     */
    Error_Code[Error_Code["ARRAY_LENGTH_TOO_SHORT"] = 4000074] = "ARRAY_LENGTH_TOO_SHORT";
    /**
     * ARRAY_EMPTY - --
     * @desc The provided array is empty.
     * --
     */
    Error_Code[Error_Code["ARRAY_EMPTY"] = 4000060] = "ARRAY_EMPTY";
    /**
     * EXPECTED_BOOLEAN - --
     * @desc The endpoint expected the provided value to be a
     * boolean.
     * --
     */
    Error_Code[Error_Code["EXPECTED_BOOLEAN"] = 4000013] = "EXPECTED_BOOLEAN";
    /**
     * EXPECTED_INTEGER - --
     * @desc The endpoint expected the provided value to be an
     * integer.
     * --
     */
    Error_Code[Error_Code["EXPECTED_INTEGER"] = 4000014] = "EXPECTED_INTEGER";
    /**
     * EXPECTED_FLOAT - --
     * @desc The endpoint expected the provided value to be a
     * float.
     * --
     */
    Error_Code[Error_Code["EXPECTED_FLOAT"] = 4000015] = "EXPECTED_FLOAT";
    /**
     * EXPECTED_STRING - --
     * @desc The endpoint expected the provided value to be a
     * string.
     * --
     */
    Error_Code[Error_Code["EXPECTED_STRING"] = 4000016] = "EXPECTED_STRING";
    /**
     * EXPECTED_OBJECT - --
     * @desc The endpoint expected the provided value to be a
     * JSON object.
     * --
     */
    Error_Code[Error_Code["EXPECTED_OBJECT"] = 4000017] = "EXPECTED_OBJECT";
    /**
     * EXPECTED_ARRAY - --
     * @desc The endpoint expected the provided value to be an
     * array or list.
     * --
     */
    Error_Code[Error_Code["EXPECTED_ARRAY"] = 4000018] = "EXPECTED_ARRAY";
    /**
     * EXPECTED_MAP - --
     * @desc The endpoint expected the provided value to be a
     * map or associative array.
     * --
     */
    Error_Code[Error_Code["EXPECTED_MAP"] = 4000079] = "EXPECTED_MAP";
    /**
     * EXPECTED_BASE64_ENCODED_BYTE_ARRAY - --
     * @desc The endpoint expected the provided value to be an
     * array encoded in base64.
     * --
     */
    Error_Code[Error_Code["EXPECTED_BASE64_ENCODED_BYTE_ARRAY"] = 4000056] = "EXPECTED_BASE64_ENCODED_BYTE_ARRAY";
    /**
     * INVALID_ARRAY_VALUE - --
     * @desc One or more objects in the array does not match the
     * array type.
     * --
     */
    Error_Code[Error_Code["INVALID_ARRAY_VALUE"] = 4000019] = "INVALID_ARRAY_VALUE";
    /**
     * INVALID_ENUM_VALUE - --
     * @desc The provided static string is not valid for the
     * field.
     * --
     */
    Error_Code[Error_Code["INVALID_ENUM_VALUE"] = 4000020] = "INVALID_ENUM_VALUE";
    /**
     * INVALID_CONTENT_TYPE - --
     * @desc Invalid content type header.
     * --
     */
    Error_Code[Error_Code["INVALID_CONTENT_TYPE"] = 4000021] = "INVALID_CONTENT_TYPE";
    /**
     * INVALID_FORM_VALUE - --
     * @desc Only relevant for applications created prior to
     * 2016-03-30. Indicates there was an error while parsing form values.
     * --
     */
    Error_Code[Error_Code["INVALID_FORM_VALUE"] = 4000022] = "INVALID_FORM_VALUE";
    /**
     * CUSTOMER_NOT_FOUND - --
     * @desc The provided customer id can't be found in the merchant's customers list.
     * --
     */
    Error_Code[Error_Code["CUSTOMER_NOT_FOUND"] = 4000023] = "CUSTOMER_NOT_FOUND";
    /**
     * BUYER_NOT_FOUND - --
     * @desc The provided buyer id can't be found
     * --
     */
    Error_Code[Error_Code["BUYER_NOT_FOUND"] = 4000121] = "BUYER_NOT_FOUND";
    /**
     * ONE_INSTRUMENT_EXPECTED - --
     * @desc A general error occurred.
     * --
     */
    Error_Code[Error_Code["ONE_INSTRUMENT_EXPECTED"] = 4000052] = "ONE_INSTRUMENT_EXPECTED";
    /**
     * NO_FIELDS_SET - --
     * @desc A general error occurred.
     * --
     */
    Error_Code[Error_Code["NO_FIELDS_SET"] = 4000053] = "NO_FIELDS_SET";
    /** DEPRECATED_FIELD_SET - Both fields retired in favor of API_VERSION_INCOMPATIBLE */
    Error_Code[Error_Code["DEPRECATED_FIELD_SET"] = 4000078] = "DEPRECATED_FIELD_SET";
    /** RETIRED_FIELD_SET - The fields are not accessible at the request api version. Use API_VERSION_INCOMPATIBLE instead. */
    Error_Code[Error_Code["RETIRED_FIELD_SET"] = 4000103] = "RETIRED_FIELD_SET";
    /**
     * TOO_MANY_MAP_ENTRIES - --
     * @desc Too many entries in the map field.
     * --
     */
    Error_Code[Error_Code["TOO_MANY_MAP_ENTRIES"] = 4000108] = "TOO_MANY_MAP_ENTRIES";
    /**
     * MAP_KEY_LENGTH_TOO_SHORT - --
     * @desc The length of one of the provided keys in the map is too short.
     * --
     */
    Error_Code[Error_Code["MAP_KEY_LENGTH_TOO_SHORT"] = 4000109] = "MAP_KEY_LENGTH_TOO_SHORT";
    /**
     * MAP_KEY_LENGTH_TOO_LONG - --
     * @desc The length of one of the provided keys in the map is too long.
     * --
     */
    Error_Code[Error_Code["MAP_KEY_LENGTH_TOO_LONG"] = 4000110] = "MAP_KEY_LENGTH_TOO_LONG";
    /**
     * CUSTOMER_MISSING_NAME - --
     * @desc The provided customer does not have a recorded name.
     * --
     */
    Error_Code[Error_Code["CUSTOMER_MISSING_NAME"] = 4000122] = "CUSTOMER_MISSING_NAME";
    /**
     * CUSTOMER_MISSING_EMAIL - --
     * @desc The provided customer does not have a recorded email.
     * --
     */
    Error_Code[Error_Code["CUSTOMER_MISSING_EMAIL"] = 4000123] = "CUSTOMER_MISSING_EMAIL";
    /**
     * INVALID_PAUSE_LENGTH - --
     * @desc The subscription cannot be paused longer than the duration of the current phase.
     * --
     */
    Error_Code[Error_Code["INVALID_PAUSE_LENGTH"] = 4000124] = "INVALID_PAUSE_LENGTH";
    /**
     * INVALID_DATE - --
     * @desc The subscription cannot be paused/resumed on the given date.
     * --
     */
    Error_Code[Error_Code["INVALID_DATE"] = 4000125] = "INVALID_DATE";
    /**
     * JOB_TEMPLATE_NAME_TAKEN - --
     * @desc There already exists a job template with the given name.
     * --
     */
    Error_Code[Error_Code["JOB_TEMPLATE_NAME_TAKEN"] = 4000138] = "JOB_TEMPLATE_NAME_TAKEN";
    /**
     * CLIENT_NOT_SUPPORTED - --
     * @desc The provided client is not supported.
     * --
     */
    Error_Code[Error_Code["CLIENT_NOT_SUPPORTED"] = 4000140] = "CLIENT_NOT_SUPPORTED";
    /**
     * UNSUPPORTED_COUNTRY - --
     * @desc The API request references an unsupported country.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_COUNTRY"] = 4000149] = "UNSUPPORTED_COUNTRY";
    /**
     * UNSUPPORTED_CURRENCY - --
     * @desc The API request references an unsupported currency.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_CURRENCY"] = 4000150] = "UNSUPPORTED_CURRENCY";
    /**
     * APPLE_TTP_PIN_TOKEN - --
     * @desc The payment was declined by the card issuer during an Apple Tap to Pay (TTP)
     * transaction with a request for the card's PIN. This code will be returned alongside
     * `CARD_DECLINED_VERIFICATION_REQUIRED` as a supplemental error, and will include an
     * issuer-provided token in the `details` field that is needed to initiate the PIN
     * collection flow on the iOS device.
     * --
     */
    Error_Code[Error_Code["APPLE_TTP_PIN_TOKEN"] = 4000151] = "APPLE_TTP_PIN_TOKEN";
    /**
     * INELIGIBLE_FOR_PREAUTHORIZATION - --
     * @desc The payment method provided does not support preauthorization.
     * Please try again using another form of payment.
     * --
     */
    Error_Code[Error_Code["INELIGIBLE_FOR_PREAUTHORIZATION"] = 4000162] = "INELIGIBLE_FOR_PREAUTHORIZATION";
    /**
     * CARD_EXPIRED - --
     * @desc The card issuer declined the request because the card is expired.
     * --
     */
    Error_Code[Error_Code["CARD_EXPIRED"] = 4000024] = "CARD_EXPIRED";
    /**
     * INVALID_EXPIRATION - --
     * @desc The expiration date for the payment card is invalid. For example,
     * it indicates a date in the past.
     * --
     */
    Error_Code[Error_Code["INVALID_EXPIRATION"] = 4000027] = "INVALID_EXPIRATION";
    /**
     * INVALID_EXPIRATION_YEAR - --
     * @desc The expiration year for the payment card is invalid. For example,
     * it indicates a year in the past or contains invalid characters.
     * --
     */
    Error_Code[Error_Code["INVALID_EXPIRATION_YEAR"] = 4000028] = "INVALID_EXPIRATION_YEAR";
    /**
     * INVALID_EXPIRATION_DATE - --
     * @desc The expiration date for the payment card is invalid. For example,
     * it contains invalid characters.
     * --
     */
    Error_Code[Error_Code["INVALID_EXPIRATION_DATE"] = 4000039] = "INVALID_EXPIRATION_DATE";
    /**
     * UNSUPPORTED_CARD_BRAND - --
     * @desc The credit card provided is not from a supported issuer.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_CARD_BRAND"] = 4000055] = "UNSUPPORTED_CARD_BRAND";
    /**
     * UNSUPPORTED_ENTRY_METHOD - --
     * @desc The entry method for the credit card (swipe, dip, tap) is not supported.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_ENTRY_METHOD"] = 4000076] = "UNSUPPORTED_ENTRY_METHOD";
    /**
     * INVALID_ENCRYPTED_CARD - --
     * @desc The encrypted card information is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_ENCRYPTED_CARD"] = 4000081] = "INVALID_ENCRYPTED_CARD";
    /**
     * INVALID_CARD - --
     * @desc The credit card cannot be validated based on the provided details.
     * --
     */
    Error_Code[Error_Code["INVALID_CARD"] = 4000040] = "INVALID_CARD";
    /**
     * PAYMENT_AMOUNT_MISMATCH - --
     * @desc The payment was declined because there was a payment amount mismatch.
     * The money amount Square was expecting does not match the amount provided.
     * --
     */
    Error_Code[Error_Code["PAYMENT_AMOUNT_MISMATCH"] = 4000141] = "PAYMENT_AMOUNT_MISMATCH";
    /**
     * GENERIC_DECLINE - --
     * @desc Square received a decline without any additional information.
     * If the payment information seems correct, the buyer can contact their
     * issuer to ask for more information.
     * --
     */
    Error_Code[Error_Code["GENERIC_DECLINE"] = 4000082] = "GENERIC_DECLINE";
    /**
     * CVV_FAILURE - --
     * @desc The card issuer declined the request because the CVV value is invalid.
     * --
     */
    Error_Code[Error_Code["CVV_FAILURE"] = 4000083] = "CVV_FAILURE";
    /**
     * ADDRESS_VERIFICATION_FAILURE - --
     * @desc The card issuer declined the request because the postal code is invalid.
     * --
     */
    Error_Code[Error_Code["ADDRESS_VERIFICATION_FAILURE"] = 4000084] = "ADDRESS_VERIFICATION_FAILURE";
    /**
     * INVALID_ACCOUNT - --
     * @desc The issuer was not able to locate the account on record.
     * --
     */
    Error_Code[Error_Code["INVALID_ACCOUNT"] = 4000085] = "INVALID_ACCOUNT";
    /**
     * CURRENCY_MISMATCH - --
     * @desc The currency associated with the payment is not valid for the provided
     * funding source. For example, a gift card funded in USD cannot be used to process
     * payments in GBP.
     * --
     */
    Error_Code[Error_Code["CURRENCY_MISMATCH"] = 4000086] = "CURRENCY_MISMATCH";
    /**
     * INSUFFICIENT_FUNDS - --
     * @desc The funding source has insufficient funds to cover the payment.
     * --
     */
    Error_Code[Error_Code["INSUFFICIENT_FUNDS"] = 4000087] = "INSUFFICIENT_FUNDS";
    /**
     * INSUFFICIENT_PERMISSIONS - --
     * @desc The Square account does not have the permissions to accept
     * this payment. For example, Square may limit which merchants are
     * allowed to receive gift card payments.
     * --
     */
    Error_Code[Error_Code["INSUFFICIENT_PERMISSIONS"] = 4000088] = "INSUFFICIENT_PERMISSIONS";
    /**
     * CARDHOLDER_INSUFFICIENT_PERMISSIONS - --
     * @desc The card issuer has declined the transaction due to restrictions on where the card can be used.
     * For example, a gift card is limited to a single merchant.
     * --
     */
    Error_Code[Error_Code["CARDHOLDER_INSUFFICIENT_PERMISSIONS"] = 4000089] = "CARDHOLDER_INSUFFICIENT_PERMISSIONS";
    /**
     * INVALID_LOCATION - --
     * @desc The Square account cannot take payments in the specified region.
     * A Square account can take payments only from the region where the account was created.
     * --
     */
    Error_Code[Error_Code["INVALID_LOCATION"] = 4000090] = "INVALID_LOCATION";
    /**
     * TRANSACTION_LIMIT - --
     * @desc The card issuer has determined the payment amount is either too high or too low.
     * The API returns the error code mostly for credit cards (for example, the card reached
     * the credit limit). However, sometimes the issuer bank can indicate the error for debit
     * or prepaid cards (for example, card has insufficient funds).
     * --
     */
    Error_Code[Error_Code["TRANSACTION_LIMIT"] = 4000091] = "TRANSACTION_LIMIT";
    /**
     * VOICE_FAILURE - --
     * @desc The card issuer declined the request because the issuer requires voice authorization from the cardholder. The seller should ask the customer to contact the card issuing bank to authorize the payment.
     * --
     */
    Error_Code[Error_Code["VOICE_FAILURE"] = 4000092] = "VOICE_FAILURE";
    /**
     * PAN_FAILURE - --
     * @desc The specified card number is invalid. For example, it is of
     * incorrect length or is incorrectly formatted.
     * --
     */
    Error_Code[Error_Code["PAN_FAILURE"] = 4000093] = "PAN_FAILURE";
    /**
     * EXPIRATION_FAILURE - --
     * @desc The card expiration date is either invalid or indicates that the
     * card is expired.
     * --
     */
    Error_Code[Error_Code["EXPIRATION_FAILURE"] = 4000094] = "EXPIRATION_FAILURE";
    /**
     * CARD_NOT_SUPPORTED - --
     * @desc The card is not supported either in the geographic region or by
     * the [merchant category code](https://developer.squareup.com/docs/locations-api#initialize-a-merchant-category-code) (MCC).
     * --
     */
    Error_Code[Error_Code["CARD_NOT_SUPPORTED"] = 4000095] = "CARD_NOT_SUPPORTED";
    /**
     * READER_NOT_SUPPORTED_FOR_COUNTRY - --
     * @desc The Square Card Reader used is not supported in the geographic region.
     * --
     */
    Error_Code[Error_Code["READER_NOT_SUPPORTED_FOR_COUNTRY"] = 4000160] = "READER_NOT_SUPPORTED_FOR_COUNTRY";
    /**
     * READER_NOT_SUPPORTED_DUE_TO_NO_EMV_READER - --
     * @desc The Square Card Reader used is not supported because there is no EMV capable reader connected (but is
     * otherwise supported in the region if there were one connected).
     * --
     */
    Error_Code[Error_Code["READER_NOT_SUPPORTED_DUE_TO_NO_EMV_READER"] = 4000161] = "READER_NOT_SUPPORTED_DUE_TO_NO_EMV_READER";
    /**
     * READER_NOT_SUPPORTED_END_OF_LIFE - --
     * @desc The Square Card Reader used is not supported anymore due to end of life.
     * --
     */
    Error_Code[Error_Code["READER_NOT_SUPPORTED_END_OF_LIFE"] = 4000163] = "READER_NOT_SUPPORTED_END_OF_LIFE";
    /**
     * ISSUER_INSTALLMENT_ERROR - --
     * @desc The authorization was declined due to an issue related to issuer-based installments. E.g.
     * installments were requested but this card does not support installments.
     * --
     */
    Error_Code[Error_Code["ISSUER_INSTALLMENT_ERROR"] = 4000152] = "ISSUER_INSTALLMENT_ERROR";
    /**
     * INVALID_PIN - --
     * @desc The card issuer declined the request because the PIN is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_PIN"] = 4000096] = "INVALID_PIN";
    /**
     * MISSING_PIN - --
     * @desc The payment is missing a required PIN.
     * --
     */
    Error_Code[Error_Code["MISSING_PIN"] = 4000119] = "MISSING_PIN";
    /**
     * MISSING_ACCOUNT_TYPE - --
     * @desc The payment is missing a required ACCOUNT_TYPE parameter.
     * --
     */
    Error_Code[Error_Code["MISSING_ACCOUNT_TYPE"] = 4000120] = "MISSING_ACCOUNT_TYPE";
    /**
     * INVALID_POSTAL_CODE - --
     * @desc The postal code is incorrectly formatted.
     * --
     */
    Error_Code[Error_Code["INVALID_POSTAL_CODE"] = 4000097] = "INVALID_POSTAL_CODE";
    /**
     * INVALID_FEES - --
     * @desc The app_fee_money on a payment is too high.
     * --
     */
    Error_Code[Error_Code["INVALID_FEES"] = 4000098] = "INVALID_FEES";
    /**
     * MANUALLY_ENTERED_PAYMENT_NOT_SUPPORTED - --
     * @desc The card must be swiped, tapped, or dipped. Payments attempted by manually entering the card number are declined.
     * --
     */
    Error_Code[Error_Code["MANUALLY_ENTERED_PAYMENT_NOT_SUPPORTED"] = 4000099] = "MANUALLY_ENTERED_PAYMENT_NOT_SUPPORTED";
    /**
     * PAYMENT_LIMIT_EXCEEDED - --
     * @desc Square declined the request because the payment amount exceeded the processing limit for this merchant.
     * --
     */
    Error_Code[Error_Code["PAYMENT_LIMIT_EXCEEDED"] = 4000100] = "PAYMENT_LIMIT_EXCEEDED";
    /**
     * GIFT_CARD_AVAILABLE_AMOUNT - --
     * @desc When a Gift Card is a payment source, you can allow taking a partial payment
     * by adding the `accept_partial_authorization` parameter in the request.
     * However, taking such a partial payment does not work if your request also includes
     * `tip_money`, `app_fee_money`, or both. Square declines such payments and returns
     * the `GIFT_CARD_AVAILABLE_AMOUNT` error.
     * For more information, see
     * [CreatePayment errors (additional information)](https://developer.squareup.com/docs/payments-api/error-codes#createpayment-errors-additional-information).
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_AVAILABLE_AMOUNT"] = 4000106] = "GIFT_CARD_AVAILABLE_AMOUNT";
    /**
     * GIFT_CARD_BUYER_DAILY_LIMIT_REACHED - --
     * @desc The buyer attempting to add value to the gift card has reached daily purchase limits.
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_BUYER_DAILY_LIMIT_REACHED"] = 4000133] = "GIFT_CARD_BUYER_DAILY_LIMIT_REACHED";
    /**
     * GIFT_CARD_INVALID_AMOUNT - --
     * @desc The specified gift card amount is zero, negative, in the incorrect currency, or too large.
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_INVALID_AMOUNT"] = 4000134] = "GIFT_CARD_INVALID_AMOUNT";
    /**
     * GIFT_CARD_MAX_VALUE_REACHED - --
     * @desc The gift card's maximum value has been reached.
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_MAX_VALUE_REACHED"] = 4000135] = "GIFT_CARD_MAX_VALUE_REACHED";
    /**
     * GIFT_CARD_MERCHANT_MAX_OUTSTANDING_BALANCE_REACHED - --
     * @desc The merchant's maximum total of outstanding gift card balances has been reached.
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_MERCHANT_MAX_OUTSTANDING_BALANCE_REACHED"] = 4000136] = "GIFT_CARD_MERCHANT_MAX_OUTSTANDING_BALANCE_REACHED";
    /**
     * GIFT_CARD_VALUE_ADDITION_LIMIT_REACHED - --
     * @desc Attempted to add an amount to a gift card that is beyond its limits.
     * --
     */
    Error_Code[Error_Code["GIFT_CARD_VALUE_ADDITION_LIMIT_REACHED"] = 4000137] = "GIFT_CARD_VALUE_ADDITION_LIMIT_REACHED";
    /**
     * ACCOUNT_UNUSABLE - --
     * @desc The account provided cannot carry out transactions.
     * --
     */
    Error_Code[Error_Code["ACCOUNT_UNUSABLE"] = 4000117] = "ACCOUNT_UNUSABLE";
    /**
     * BUYER_REFUSED_PAYMENT - --
     * @desc Bank account rejected or was not authorized for the payment.
     * --
     */
    Error_Code[Error_Code["BUYER_REFUSED_PAYMENT"] = 4000118] = "BUYER_REFUSED_PAYMENT";
    /**
     * DELAYED_TRANSACTION_EXPIRED - --
     * @desc The application tried to update a delayed-capture payment that has expired.
     * --
     */
    Error_Code[Error_Code["DELAYED_TRANSACTION_EXPIRED"] = 4000041] = "DELAYED_TRANSACTION_EXPIRED";
    /**
     * DELAYED_TRANSACTION_CANCELED - --
     * @desc The application tried to cancel a delayed-capture payment that was already cancelled.
     * --
     */
    Error_Code[Error_Code["DELAYED_TRANSACTION_CANCELED"] = 4000042] = "DELAYED_TRANSACTION_CANCELED";
    /**
     * DELAYED_TRANSACTION_CAPTURED - --
     * @desc The application tried to capture a delayed-capture payment that was already captured.
     * --
     */
    Error_Code[Error_Code["DELAYED_TRANSACTION_CAPTURED"] = 4000043] = "DELAYED_TRANSACTION_CAPTURED";
    /**
     * DELAYED_TRANSACTION_FAILED - --
     * @desc The application tried to update a delayed-capture payment that failed.
     * --
     */
    Error_Code[Error_Code["DELAYED_TRANSACTION_FAILED"] = 4000044] = "DELAYED_TRANSACTION_FAILED";
    /**
     * CARD_TOKEN_EXPIRED - --
     * @desc The provided card token (nonce) has expired.
     * --
     */
    Error_Code[Error_Code["CARD_TOKEN_EXPIRED"] = 4000045] = "CARD_TOKEN_EXPIRED";
    /**
     * CARD_TOKEN_USED - --
     * @desc The provided card token (nonce) was already used to process the payment or refund.
     * --
     */
    Error_Code[Error_Code["CARD_TOKEN_USED"] = 4000046] = "CARD_TOKEN_USED";
    /**
     * AMOUNT_TOO_HIGH - --
     * @desc The requested payment amount is too high for the provided payment source.
     * --
     */
    Error_Code[Error_Code["AMOUNT_TOO_HIGH"] = 4000047] = "AMOUNT_TOO_HIGH";
    /**
     * UNSUPPORTED_INSTRUMENT_TYPE - --
     * @desc The API request references an unsupported instrument type.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_INSTRUMENT_TYPE"] = 4000054] = "UNSUPPORTED_INSTRUMENT_TYPE";
    /**
     * REFUND_AMOUNT_INVALID - --
     * @desc The requested refund amount exceeds the amount available to refund.
     * --
     */
    Error_Code[Error_Code["REFUND_AMOUNT_INVALID"] = 4000048] = "REFUND_AMOUNT_INVALID";
    /**
     * REFUND_ALREADY_PENDING - --
     * @desc The payment already has a pending refund.
     * --
     */
    Error_Code[Error_Code["REFUND_ALREADY_PENDING"] = 4000049] = "REFUND_ALREADY_PENDING";
    /**
     * PAYMENT_NOT_REFUNDABLE - --
     * @desc The payment is not refundable. For example, the payment is too old to be refunded.
     * --
     */
    Error_Code[Error_Code["PAYMENT_NOT_REFUNDABLE"] = 4000050] = "PAYMENT_NOT_REFUNDABLE";
    /**
     * PAYMENT_NOT_REFUNDABLE_DUE_TO_DISPUTE - --
     * @desc The payment is not refundable because it has been disputed.
     * --
     */
    Error_Code[Error_Code["PAYMENT_NOT_REFUNDABLE_DUE_TO_DISPUTE"] = 4000165] = "PAYMENT_NOT_REFUNDABLE_DUE_TO_DISPUTE";
    /**
     * REFUND_DECLINED - --
     * @desc Request failed - The card issuer declined the refund.
     * --
     */
    Error_Code[Error_Code["REFUND_DECLINED"] = 4000112] = "REFUND_DECLINED";
    /**
     * INSUFFICIENT_PERMISSIONS_FOR_REFUND - --
     * @desc The Square account does not have the permissions to process this refund.
     * --
     */
    Error_Code[Error_Code["INSUFFICIENT_PERMISSIONS_FOR_REFUND"] = 4000145] = "INSUFFICIENT_PERMISSIONS_FOR_REFUND";
    /**
     * INVALID_CARD_DATA - --
     * @desc Generic error - the provided card data is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_CARD_DATA"] = 4000051] = "INVALID_CARD_DATA";
    /**
     * SOURCE_USED - --
     * @desc The provided source id was already used to create a card.
     * --
     */
    Error_Code[Error_Code["SOURCE_USED"] = 4000113] = "SOURCE_USED";
    /**
     * SOURCE_EXPIRED - --
     * @desc The provided source id has expired.
     * --
     */
    Error_Code[Error_Code["SOURCE_EXPIRED"] = 4000114] = "SOURCE_EXPIRED";
    /**
     * UNSUPPORTED_LOYALTY_REWARD_TIER - --
     * @desc The referenced loyalty program reward tier is not supported.
     * This could happen if the reward tier created in a first party
     * application is incompatible with the Loyalty API.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_LOYALTY_REWARD_TIER"] = 4000115] = "UNSUPPORTED_LOYALTY_REWARD_TIER";
    /**
     * LOCATION_MISMATCH - --
     * @desc Generic error - the given location does not matching what is expected.
     * --
     */
    Error_Code[Error_Code["LOCATION_MISMATCH"] = 4000077] = "LOCATION_MISMATCH";
    /**
     * ORDER_EXPIRED - --
     * @desc The requested order has expired and cannot be updated.
     * --
     */
    Error_Code[Error_Code["ORDER_EXPIRED"] = 4000062] = "ORDER_EXPIRED";
    /**
     * ORDER_ALREADY_USED - --
     * @desc The order was already used.
     * --
     */
    Error_Code[Error_Code["ORDER_ALREADY_USED"] = 4000067] = "ORDER_ALREADY_USED";
    /**
     * ORDER_TOO_MANY_CATALOG_OBJECTS - --
     * @desc The creation request contains too many catalog IDs.
     * --
     */
    Error_Code[Error_Code["ORDER_TOO_MANY_CATALOG_OBJECTS"] = 4000072] = "ORDER_TOO_MANY_CATALOG_OBJECTS";
    /**
     * INSUFFICIENT_INVENTORY - --
     * @desc The referenced inventory item has insufficient inventory.
     * --
     */
    Error_Code[Error_Code["INSUFFICIENT_INVENTORY"] = 4000063] = "INSUFFICIENT_INVENTORY";
    /**
     * PRICE_MISMATCH - --
     * @desc There is a price mismatch.
     * --
     */
    Error_Code[Error_Code["PRICE_MISMATCH"] = 4000064] = "PRICE_MISMATCH";
    /**
     * VERSION_MISMATCH - --
     * @desc The provided object version does not match the expected value.
     * --
     */
    Error_Code[Error_Code["VERSION_MISMATCH"] = 4000065] = "VERSION_MISMATCH";
    /**
     * IDEMPOTENCY_KEY_REUSED - --
     * @desc The provided idempotency key has already been used.
     * --
     */
    Error_Code[Error_Code["IDEMPOTENCY_KEY_REUSED"] = 4000066] = "IDEMPOTENCY_KEY_REUSED";
    /**
     * UNEXPECTED_VALUE - --
     * @desc General error - the value provided was unexpected.
     * --
     */
    Error_Code[Error_Code["UNEXPECTED_VALUE"] = 4000068] = "UNEXPECTED_VALUE";
    /**
     * SANDBOX_NOT_SUPPORTED - --
     * @desc The API request is not supported in sandbox.
     * --
     */
    Error_Code[Error_Code["SANDBOX_NOT_SUPPORTED"] = 4000069] = "SANDBOX_NOT_SUPPORTED";
    /**
     * INVALID_EMAIL_ADDRESS - --
     * @desc The provided email address is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_EMAIL_ADDRESS"] = 4000070] = "INVALID_EMAIL_ADDRESS";
    /**
     * INVALID_PHONE_NUMBER - --
     * @desc The provided phone number is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_PHONE_NUMBER"] = 4000075] = "INVALID_PHONE_NUMBER";
    /**
     * CHECKOUT_EXPIRED - --
     * @desc The provided checkout URL has expired.
     * --
     */
    Error_Code[Error_Code["CHECKOUT_EXPIRED"] = 4000071] = "CHECKOUT_EXPIRED";
    /**
     * BAD_CERTIFICATE - --
     * @desc Bad certificate.
     * --
     */
    Error_Code[Error_Code["BAD_CERTIFICATE"] = 4000080] = "BAD_CERTIFICATE";
    /**
     * INVALID_SQUARE_VERSION_FORMAT - --
     * @desc The provided Square-Version is incorrectly formatted.
     * --
     */
    Error_Code[Error_Code["INVALID_SQUARE_VERSION_FORMAT"] = 4000101] = "INVALID_SQUARE_VERSION_FORMAT";
    /**
     * API_VERSION_INCOMPATIBLE - --
     * @desc The provided Square-Version is incompatible with the requested action.
     * --
     */
    Error_Code[Error_Code["API_VERSION_INCOMPATIBLE"] = 4000102] = "API_VERSION_INCOMPATIBLE";
    /**
     * INVALID_URL - --
     * @desc The provided API URL is invalid.
     * --
     */
    Error_Code[Error_Code["INVALID_URL"] = 4000104] = "INVALID_URL";
    /**
     * HTTPS_ONLY - --
     * @desc HTTPS only.
     * --
     */
    Error_Code[Error_Code["HTTPS_ONLY"] = 4000105] = "HTTPS_ONLY";
    /**
     * UNREACHABLE_URL - --
     * @desc The provided URL is unreachable.
     * --
     */
    Error_Code[Error_Code["UNREACHABLE_URL"] = 4000107] = "UNREACHABLE_URL";
    /**
     * SESSION_EXPIRED - --
     * @desc A session associated with the payment has expired.
     * --
     */
    Error_Code[Error_Code["SESSION_EXPIRED"] = 4000111] = "SESSION_EXPIRED";
    /**
     * INVALID_VERIFICATION_CODE - --
     * @desc The verification code provided is invalid.
     */
    Error_Code[Error_Code["INVALID_VERIFICATION_CODE"] = 4000142] = "INVALID_VERIFICATION_CODE";
    /**
     * CARD_PRESENCE_REQUIRED - --
     * @desc The transaction requires that a card be present.
     * --
     */
    Error_Code[Error_Code["CARD_PRESENCE_REQUIRED"] = 4000146] = "CARD_PRESENCE_REQUIRED";
    /**
     * UNSUPPORTED_SOURCE_TYPE - --
     * @desc The API request references an unsupported source type.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_SOURCE_TYPE"] = 4000147] = "UNSUPPORTED_SOURCE_TYPE";
    /**
     * CARD_MISMATCH - --
     * @desc The provided card does not match what is expected.
     * --
     */
    Error_Code[Error_Code["CARD_MISMATCH"] = 4000148] = "CARD_MISMATCH";
    /**
     * PLAID_ERROR - --
     * @desc Generic plaid error
     * --
     */
    Error_Code[Error_Code["PLAID_ERROR"] = 4000300] = "PLAID_ERROR";
    /**
     * PLAID_ERROR_ITEM_LOGIN_REQUIRED - --
     * @desc Plaid error - ITEM_LOGIN_REQUIRED
     * --
     */
    Error_Code[Error_Code["PLAID_ERROR_ITEM_LOGIN_REQUIRED"] = 4000301] = "PLAID_ERROR_ITEM_LOGIN_REQUIRED";
    /**
     * PLAID_ERROR_RATE_LIMIT - --
     * @desc Plaid error - RATE_LIMIT
     * --
     */
    Error_Code[Error_Code["PLAID_ERROR_RATE_LIMIT"] = 4000302] = "PLAID_ERROR_RATE_LIMIT";
    /**
     * CALCULATE_FULFILLMENT_RATES_NO_PROFILES_CONFIGURED - --
     * @desc No profiles are configured for the fufillment type requested.
     * --
     */
    Error_Code[Error_Code["CALCULATE_FULFILLMENT_RATES_NO_PROFILES_CONFIGURED"] = 4000400] = "CALCULATE_FULFILLMENT_RATES_NO_PROFILES_CONFIGURED";
    /**
     * CALCULATE_FULFILLMENT_RATES_SHIPMENT_DESTINATION_NOT_CONFIGURED - --
     * @desc No profiles are configured with the requested shipment destination.
     * --
     */
    Error_Code[Error_Code["CALCULATE_FULFILLMENT_RATES_SHIPMENT_DESTINATION_NOT_CONFIGURED"] = 4000401] = "CALCULATE_FULFILLMENT_RATES_SHIPMENT_DESTINATION_NOT_CONFIGURED";
    /**
     * CALCULATE_FULFILLMENT_RATES_INVALID_RECIPIENT_ADDRESS - --
     * @desc No profiles are configured with the requested shipment destination.
     * --
     */
    Error_Code[Error_Code["CALCULATE_FULFILLMENT_RATES_INVALID_RECIPIENT_ADDRESS"] = 4000402] = "CALCULATE_FULFILLMENT_RATES_INVALID_RECIPIENT_ADDRESS";
    /**
     * CALCULATE_FULFILLMENT_RATES_FULFILLMENT_TYPE_NOT_SUPPORTED - --
     * @desc Fulfillment type is not supported for calculating fulfillment rates.
     */
    Error_Code[Error_Code["CALCULATE_FULFILLMENT_RATES_FULFILLMENT_TYPE_NOT_SUPPORTED"] = 4000403] = "CALCULATE_FULFILLMENT_RATES_FULFILLMENT_TYPE_NOT_SUPPORTED";
    /**
     * FULFILLMENT_RATE_PROFILE_DUPLICATE_ITEM - --
     * @desc A different item level profile has this item id
     */
    Error_Code[Error_Code["FULFILLMENT_RATE_PROFILE_DUPLICATE_ITEM"] = 4000404] = "FULFILLMENT_RATE_PROFILE_DUPLICATE_ITEM";
    /**
     * FULFILLMENT_RATE_PROFILE_INVALID_ITEM - --
     * @desc The item id provided for this profile is invalid
     */
    Error_Code[Error_Code["FULFILLMENT_RATE_PROFILE_INVALID_ITEM"] = 4000405] = "FULFILLMENT_RATE_PROFILE_INVALID_ITEM";
    /**
     * CUSTOMS_DECLARATION_NO_VALUE - --
     * @desc No value declared for customs for international shipments.
     * --
     */
    Error_Code[Error_Code["CUSTOMS_DECLARATION_NO_VALUE"] = 4000500] = "CUSTOMS_DECLARATION_NO_VALUE";
    /**
     * CUSTOMS_DECLARATION_NO_WEIGHT - --
     * @desc No weight declared for customs for international shipments.
     * --
     */
    Error_Code[Error_Code["CUSTOMS_DECLARATION_NO_WEIGHT"] = 4000501] = "CUSTOMS_DECLARATION_NO_WEIGHT";
    /**
     * CARD_DECLINED - --
     * @desc The card was declined.
     * --
     */
    Error_Code[Error_Code["CARD_DECLINED"] = 4020001] = "CARD_DECLINED";
    /**
     * VERIFY_CVV_FAILURE - --
     * @desc The CVV could not be verified.
     * --
     */
    Error_Code[Error_Code["VERIFY_CVV_FAILURE"] = 4020002] = "VERIFY_CVV_FAILURE";
    /**
     * VERIFY_AVS_FAILURE - --
     * @desc The AVS could not be verified.
     * --
     */
    Error_Code[Error_Code["VERIFY_AVS_FAILURE"] = 4020003] = "VERIFY_AVS_FAILURE";
    /**
     * CARD_DECLINED_CALL_ISSUER - --
     * @desc The payment card was declined with a request
     * for the card holder to call the issuer.
     * --
     */
    Error_Code[Error_Code["CARD_DECLINED_CALL_ISSUER"] = 4020004] = "CARD_DECLINED_CALL_ISSUER";
    /**
     * CARD_DECLINED_VERIFICATION_REQUIRED - --
     * @desc The payment card was declined with a request
     * for additional verification.
     * --
     */
    Error_Code[Error_Code["CARD_DECLINED_VERIFICATION_REQUIRED"] = 4020005] = "CARD_DECLINED_VERIFICATION_REQUIRED";
    /**
     * BAD_EXPIRATION - --
     * @desc The card expiration date is either missing or
     * incorrectly formatted.
     * --
     */
    Error_Code[Error_Code["BAD_EXPIRATION"] = 4020006] = "BAD_EXPIRATION";
    /**
     * CHIP_INSERTION_REQUIRED - --
     * @desc The card issuer requires that the card be read
     * using a chip reader.
     * --
     */
    Error_Code[Error_Code["CHIP_INSERTION_REQUIRED"] = 4020007] = "CHIP_INSERTION_REQUIRED";
    /**
     * ALLOWABLE_PIN_TRIES_EXCEEDED - --
     * @desc The card has exhausted its available pin entry
     * retries set by the card issuer. Resolving the error typically requires the
     * card holder to contact the card issuer.
     * --
     */
    Error_Code[Error_Code["ALLOWABLE_PIN_TRIES_EXCEEDED"] = 4020008] = "ALLOWABLE_PIN_TRIES_EXCEEDED";
    /**
     * RESERVATION_DECLINED - --
     * @desc The card issuer declined the refund.
     * --
     */
    Error_Code[Error_Code["RESERVATION_DECLINED"] = 4020009] = "RESERVATION_DECLINED";
    /**
     * BLOCKED_BY_BLOCKLIST - --
     * @desc The card issuer declined the refund.
     * --
     */
    Error_Code[Error_Code["BLOCKED_BY_BLOCKLIST"] = 4020010] = "BLOCKED_BY_BLOCKLIST";
    /**
     * FULFILLMENT_PREFERENCES_RESTRICTED_DATE_NOT_UNIQUE - --
     * @desc This restricted date is a duplicate within the list.
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_RESTRICTED_DATE_NOT_UNIQUE"] = 4000126] = "FULFILLMENT_PREFERENCES_RESTRICTED_DATE_NOT_UNIQUE";
    /**
     * FULFILLMENT_PREFERENCES_INVALID_SCHEDULING_DATETIME - --
     * @desc The datetime value is not in the correct format per app business logic.
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_INVALID_SCHEDULING_DATETIME"] = 4000127] = "FULFILLMENT_PREFERENCES_INVALID_SCHEDULING_DATETIME";
    /**
     * FULFILLMENT_PREFERENCES_INVALID_FULFILLMENT_AVAILABILITY_WINDOW - --
     * @desc Parameters being used for FulfillmentAvailabilityWindow object are not valid.
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_INVALID_FULFILLMENT_AVAILABILITY_WINDOW"] = 4000128] = "FULFILLMENT_PREFERENCES_INVALID_FULFILLMENT_AVAILABILITY_WINDOW";
    /**
     * FULFILLMENT_PREFERENCES_FULFILLMENT_SCHEDULE_NOT_ALLOWED - --
     * @desc Fulfillment Preferences with fulfillment schedules cannot be assigned to a CATALOG_ITEM
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_FULFILLMENT_SCHEDULE_NOT_ALLOWED"] = 4000129] = "FULFILLMENT_PREFERENCES_FULFILLMENT_SCHEDULE_NOT_ALLOWED";
    /**
     * FULFILLMENT_PREFERENCES_ASSIGNMENT_IS_IMMUTABLE - --
     * @desc Unable to re-assign preferences assignment. Preferences assignment is a write-once field.
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_ASSIGNMENT_IS_IMMUTABLE"] = 4000130] = "FULFILLMENT_PREFERENCES_ASSIGNMENT_IS_IMMUTABLE";
    /**
     * INVALID_TIMEZONE - --
     * @desc Value is not a valid timezone.
     * --
     */
    Error_Code[Error_Code["INVALID_TIMEZONE"] = 4000131] = "INVALID_TIMEZONE";
    /**
     * UNKNOWN_BODY_PARAMETER - --
     * @desc The body parameter is not recognized by the requested endpoint.
     * --
     */
    Error_Code[Error_Code["UNKNOWN_BODY_PARAMETER"] = 4000132] = "UNKNOWN_BODY_PARAMETER";
    /**
     * FULFILLMENT_PREFERENCES_CONFLICTING_ASSIGNMENT_TYPE - --
     * @desc The provided preferences assignment types should be consistent within request
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_CONFLICTING_ASSIGNMENT_TYPE"] = 4000139] = "FULFILLMENT_PREFERENCES_CONFLICTING_ASSIGNMENT_TYPE";
    /**
     * SCHEDULE_UPDATES_DUPLICATE_EXECUTE_AT - --
     * @desc In the context of schedule updates, there can't be more than one update schedule for execution for the same object and property type.
     * --
     */
    Error_Code[Error_Code["SCHEDULE_UPDATES_DUPLICATE_EXECUTE_AT"] = 4000153] = "SCHEDULE_UPDATES_DUPLICATE_EXECUTE_AT";
    /**
     * SCHEDULE_UPDATES_PAST_EXECUTE_AT - --
     * @desc In the context of schedule updates, to create a schedule transaction, the execute at time must be in the future.
     * --
     */
    Error_Code[Error_Code["SCHEDULE_UPDATES_PAST_EXECUTE_AT"] = 4000154] = "SCHEDULE_UPDATES_PAST_EXECUTE_AT";
    /**
     * FULFILLMENT_PREFERENCES_ASSIGNMENT_REQUIRED - --
     * @desc An assignment is required for this type of request.
     * --
     */
    Error_Code[Error_Code["FULFILLMENT_PREFERENCES_ASSIGNMENT_REQUIRED"] = 4000155] = "FULFILLMENT_PREFERENCES_ASSIGNMENT_REQUIRED";
    /**
     * ITEMS_BULK_BULK_ACTIONS_INVALID_ITEM - --
     * @desc Invalid item encountered during bulk actions.
     * --
     */
    Error_Code[Error_Code["ITEMS_BULK_BULK_ACTIONS_INVALID_ITEM"] = 4000156] = "ITEMS_BULK_BULK_ACTIONS_INVALID_ITEM";
    /**
     * ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_PERCENTAGE - --
     * @desc Invalid percentage error encountered during bulk actions.
     * --
     */
    Error_Code[Error_Code["ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_PERCENTAGE"] = 4000157] = "ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_PERCENTAGE";
    /**
     * ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_AMOUNT - --
     * @desc Invalid amount error encountered during bulk actions.
     * --
     */
    Error_Code[Error_Code["ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_AMOUNT"] = 4000158] = "ITEMS_BULK_BULK_ACTIONS_SALE_PRICE_INVALID_AMOUNT";
    /**
     * ITEMS_BULK_BULK_ACTIONS_NO_ELIGIBLE_ITEMS_FOUND - --
     * @desc No eligible items found during during the bulk action execution.
     * --
     */
    Error_Code[Error_Code["ITEMS_BULK_BULK_ACTIONS_NO_ELIGIBLE_ITEMS_FOUND"] = 4000159] = "ITEMS_BULK_BULK_ACTIONS_NO_ELIGIBLE_ITEMS_FOUND";
    /**
     * ITEMS_INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY - --
     * @desc A catalog category with a free text donation name has a non-donation item for a canadian seller.
     * --
     */
    Error_Code[Error_Code["ITEMS_INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY"] = 4000164] = "ITEMS_INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY";
    /**
     * NOT_FOUND - --
     * @desc Not Found - a general error occurred.
     * --
     */
    Error_Code[Error_Code["NOT_FOUND"] = 4040000] = "NOT_FOUND";
    /**
     * APPLE_PAYMENT_PROCESSING_CERTIFICATE_HASH_NOT_FOUND - --
     * @desc Square could not find the associated Apple Pay certificate.
     * --
     */
    Error_Code[Error_Code["APPLE_PAYMENT_PROCESSING_CERTIFICATE_HASH_NOT_FOUND"] = 4040001] = "APPLE_PAYMENT_PROCESSING_CERTIFICATE_HASH_NOT_FOUND";
    /**
     * METHOD_NOT_ALLOWED - --
     * @desc Method Not Allowed - a general error occurred.
     * --
     */
    Error_Code[Error_Code["METHOD_NOT_ALLOWED"] = 4050000] = "METHOD_NOT_ALLOWED";
    /**
     * NOT_ACCEPTABLE - --
     * @desc Not Acceptable - a general error occurred.
     * --
     */
    Error_Code[Error_Code["NOT_ACCEPTABLE"] = 4060000] = "NOT_ACCEPTABLE";
    /**
     * REQUEST_TIMEOUT - --
     * @desc Request Timeout - a general error occurred.
     * --
     */
    Error_Code[Error_Code["REQUEST_TIMEOUT"] = 4080000] = "REQUEST_TIMEOUT";
    /**
     * CONFLICT - --
     * @desc Conflict - a general error occurred.
     * --
     */
    Error_Code[Error_Code["CONFLICT"] = 4090000] = "CONFLICT";
    /**
     * GONE - --
     * @desc The target resource is no longer available and this
     * condition is likely to be permanent.
     * --
     */
    Error_Code[Error_Code["GONE"] = 4100000] = "GONE";
    /**
     * REQUEST_ENTITY_TOO_LARGE - --
     * @desc Request Entity Too Large - a general error occurred.
     * --
     */
    Error_Code[Error_Code["REQUEST_ENTITY_TOO_LARGE"] = 4130000] = "REQUEST_ENTITY_TOO_LARGE";
    /**
     * UNSUPPORTED_MEDIA_TYPE - --
     * @desc Unsupported Media Type - a general error occurred.
     * --
     */
    Error_Code[Error_Code["UNSUPPORTED_MEDIA_TYPE"] = 4150000] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * UNPROCESSABLE_ENTITY - --
     * @desc Unprocessable Entity - a general error occurred.
     * --
     */
    Error_Code[Error_Code["UNPROCESSABLE_ENTITY"] = 4220000] = "UNPROCESSABLE_ENTITY";
    /**
     * RATE_LIMITED - --
     * @desc Rate Limited - a general error occurred.
     * --
     */
    Error_Code[Error_Code["RATE_LIMITED"] = 4290000] = "RATE_LIMITED";
    /**
     * CLIENT_CLOSED_REQUEST - -------------------------------------------------------------------------
     * 499 Client Closed Request
     * External clients are not supposed to see this response code as used to reflect
     * when clients close the connection before we're able to serve a response.
     * This non-standard response code was adopted by ngnix.
     * -------------------------------------------------------------------------
     */
    Error_Code[Error_Code["CLIENT_CLOSED_REQUEST"] = 4990000] = "CLIENT_CLOSED_REQUEST";
    /**
     * NOT_IMPLEMENTED - --
     * @desc Not Implemented - a general error occurred.
     * --
     */
    Error_Code[Error_Code["NOT_IMPLEMENTED"] = 5010000] = "NOT_IMPLEMENTED";
    /**
     * BAD_GATEWAY - --
     * @desc Bad Gateway - a general error occurred.
     * --
     */
    Error_Code[Error_Code["BAD_GATEWAY"] = 5020000] = "BAD_GATEWAY";
    /**
     * SERVICE_UNAVAILABLE - --
     * @desc Service Unavailable - a general error occurred.
     * --
     */
    Error_Code[Error_Code["SERVICE_UNAVAILABLE"] = 5030000] = "SERVICE_UNAVAILABLE";
    /**
     * TEMPORARY_ERROR - --
     * @desc A temporary internal error occurred. You can safely retry your call
     * using the same idempotency key.
     * --
     */
    Error_Code[Error_Code["TEMPORARY_ERROR"] = 5030001] = "TEMPORARY_ERROR";
    /**
     * GATEWAY_TIMEOUT - --
     * @desc Gateway Timeout - a general error occurred.
     * --
     */
    Error_Code[Error_Code["GATEWAY_TIMEOUT"] = 5040000] = "GATEWAY_TIMEOUT";
    Error_Code[Error_Code["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Error_Code || (Error_Code = {}));
function createBaseMethodErrorCodes() {
    return { $type: "squareup.connect.v2.resources.MethodErrorCodes", value: [] };
}
export const MethodErrorCodes = {
    $type: "squareup.connect.v2.resources.MethodErrorCodes",
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.value) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMethodErrorCodes();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.value.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.value.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MethodErrorCodes.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMethodErrorCodes();
        message.value = object.value?.map((e) => e) || [];
        return message;
    },
};
function createBaseError() {
    return {
        $type: "squareup.connect.v2.resources.Error",
        category: undefined,
        code: undefined,
        detail: undefined,
        field: undefined,
        obligations: [],
    };
}
export const Error = {
    $type: "squareup.connect.v2.resources.Error",
    encode(message, writer = _m0.Writer.create()) {
        if (message.category !== undefined) {
            writer.uint32(32).int32(message.category);
        }
        if (message.code !== undefined) {
            writer.uint32(8).int32(message.code);
        }
        if (message.detail !== undefined) {
            writer.uint32(18).string(message.detail);
        }
        if (message.field !== undefined) {
            writer.uint32(26).string(message.field);
        }
        writer.uint32(42).fork();
        for (const v of message.obligations) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.category = reader.int32();
                    continue;
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.code = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.detail = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.field = reader.string();
                    continue;
                case 5:
                    if (tag === 40) {
                        message.obligations.push(reader.int32());
                        continue;
                    }
                    if (tag === 42) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.obligations.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Error.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseError();
        message.category = object.category ?? undefined;
        message.code = object.code ?? undefined;
        message.detail = object.detail ?? undefined;
        message.field = object.field ?? undefined;
        message.obligations = object.obligations?.map((e) => e) || [];
        return message;
    },
};
function createBaseErrorResponse() {
    return { $type: "squareup.connect.v2.resources.ErrorResponse", errors: [] };
}
export const ErrorResponse = {
    $type: "squareup.connect.v2.resources.ErrorResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.errors) {
            Error.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseErrorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(Error.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ErrorResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseErrorResponse();
        message.errors = object.errors?.map((e) => Error.fromPartial(e)) || [];
        return message;
    },
};
